import { MakeModelMenuAd } from "./make_model_menu_ad";
import { createWindowFunctionsForAdSetup } from "./setup/ad_slot_setup";
import { listenForCookieConsentThenDisplayAds } from "./setup/cookie_consent";
import { registerListenersForAdLifecycleEvents } from "./ad_lifecycle_callbacks";
import { registerListenersForEventsInsideAds } from "./ad_behaviours";
import { setupAndEnablePubAdsService } from "./setup/pub_ads_service_setup";
import { hideSlotsIfUserBlocksAds } from "./setup/blocker_scanner";

export default function initializeGoogleAd() {
  // Do not run this function more than once, or we register all the event listeners twice.
  if (window.carwowGoogleAdsInitialized) {
    return;
  }

  createWindowFunctionsForAdSetup();

  customElements.define('carwow-google-ads', MakeModelMenuAd);

  registerListenersForAdLifecycleEvents();
  registerListenersForEventsInsideAds();

  setupAndEnablePubAdsService()

  // callbacks in this array were queued from Rails views.
  // We've waited because they rely on the service being setup and all the eventListeners from being setup
  // Now we can run them
  window.carwowGoogleTag.forEach( callback => callback());
  // From now on, execute callbacks as soon as they're added to the array
  window.carwowGoogleTag.push = (callback) => { callback(); };

  listenForCookieConsentThenDisplayAds();
  hideSlotsIfUserBlocksAds()

  // Stop the function from running subsequently.
  window.carwowGoogleAdsInitialized = true;

}
